import { ContentState, EditorState } from 'draft-js';

const createEditorState = (text: string) =>
  EditorState.createWithContent(ContentState.createFromText(text));

export { createEditorState };
